module.exports = __webpack_public_path__ + "media/volvo/assets/images/volvo_s80@2x-941eaeb4e7dad6489e6567923e04e316.png";